import { Component, OnInit, TemplateRef, ViewChild } from '@angular/core';
import { AbstractControl, FormBuilder, FormGroup, Validators } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { ICertificadoDependenciaDTO } from 'src/app/core/dto/certificado-dependencia.dto';
import { ICertificadoTipoDTO } from 'src/app/core/dto/certificado-tipo.dto';
import { IPeriodo } from 'src/app/core/dto/periodo.dto';
import { CerCerTipoService } from 'src/app/core/servicios/cer-cer-tipo.service';
import { CertificadoDependenciaService } from 'src/app/core/servicios/certificado-dependencia.service';
import { CertificadoTipoService } from 'src/app/core/servicios/certificado-tipo.service';
import { PeriodoService } from 'src/app/core/servicios/periodo.service';
import { ModalCargandoComponent } from 'src/app/shared/componentes/modal-cargando/modal-cargando.component';
import { ModalErrorComponent } from 'src/app/shared/componentes/modal-error/modal-error.component';
import * as fileSaver from 'file-saver';
import { UtilidadService } from 'src/app/core/servicios/utilidad.service';
import { SeguridadService } from 'src/app/core/servicios/seguridad.service';
import { ICertificadoInfoDTO } from 'src/app/core/dto/certificado-info.dto';
import { CustomValidator } from 'src/app/shared/validators/custom-validator';

@Component({
  selector: 'app-menu-opciones-certificados',
  templateUrl: './menu-opciones-certificados.component.html',
  styleUrls: ['./menu-opciones-certificados.component.css']
})
export class MenuOpcionesCertificadosComponent implements OnInit {
  
  @ViewChild('popupVistaPrevia', { static: false }) popupVistaPrevia!: TemplateRef<any>;

  public formulario: FormGroup;
  public titulo: string = 'Menú de opciones';
  public liqCodigo : string = '';
  public facCodigo!: number;
  public litCodigo!: number;
  public encabezadosDeseleccionados: string[] = ['Tipo de certificado','Acción'];
  public encabezadosSeleccionados: string[] = ['Tipo de certificado seleccionado','Acción'];
  public dependencias: ICertificadoDependenciaDTO[] = [];
  public tipoCertificados: ICertificadoTipoDTO[] = [];
  public tcSeleccionados: ICertificadoTipoDTO[] = [];
  public periodos: IPeriodo[] = [];
  public periodosFin: IPeriodo[] = [];
  public codigoEstudiante: string = '';
  public certificadoInfo!: ICertificadoInfoDTO;

  constructor(
    private router: Router,
    private route:ActivatedRoute,
    private modalService: NgbModal,
    private cerdService: CertificadoDependenciaService,
    private certService: CertificadoTipoService,
    private cerCerTipoService: CerCerTipoService,
    private fb: FormBuilder,
    private periodoService: PeriodoService,
    private utilidadService: UtilidadService,
    private seguridadService: SeguridadService
    ) { 
      this.liqCodigo = this.route.snapshot.params.liqCodigo;
      this.facCodigo = this.route.snapshot.params.facCodigo;
      this.litCodigo = this.route.snapshot.params.litCodigo;

      this.formulario = this.fb.group({
        cerDependencia: this.fb.control(null, Validators.compose([Validators.required])),
        periodoInicio: this.fb.control(null, Validators.compose([CustomValidator.validateRequiredPeriodos(this.litCodigo)])),
        periodoFin: this.fb.control(null, Validators.compose([CustomValidator.validateRequiredPeriodos(this.litCodigo)])),
        cerTipo: this.fb.control(null, Validators.compose([Validators.required])),
      });
    }

  ngOnInit(): void {
    
    this.findAllDependencias();
    this.findCodigoEstudiante();
  }

  // Getters

  
  getCerDependencia(): AbstractControl | null {
    return this.formulario.get('cerDependencia');
  }

  getPeriodoInicio(): AbstractControl | null {
    return this.formulario.get('periodoInicio');
  }

  getPeriodoFin(): AbstractControl | null {
    return this.formulario.get('periodoFin');
  }

  getCerTipo(): AbstractControl | null {
    return this.formulario.get('cerTipo');
  }

  // Evnetos

  onChangeCerDependencia():void{
    this.tipoCertificados = [];
    this.tcSeleccionados = [];
    this.periodosFin = [];
    this.periodos = [];
    const cerdCodigo = this.getCerDependencia()?.value;
    this.findAllCertificadoTiposByCerdcodigoAndLiqcodigo(cerdCodigo,this.liqCodigo);
    this.formulario.patchValue({ periodoInicio: '', periodoFin: '', cerTipo: '' });
    this.getPeriodos();
  }

  onChangePerInicio(): void{
    this.getPeriodoFin()?.setValue('');
    const periodoInicio = this.getPeriodoInicio()?.value;
    this.periodosFin = this.periodos.filter(per => per.per_codigo >= periodoInicio);
  }

  onClickSeleccionarTodos(){
    this.tcSeleccionados = [...this.tcSeleccionados, ...this.tipoCertificados].sort((a, b) => (a.cert_codigo < b.cert_codigo ? -1 : 1));
    this.tipoCertificados = [];
    this.getCerTipo()?.setValue(this.tcSeleccionados);
  }

  onClickSeleccionar(tc:ICertificadoTipoDTO,i:number){
    this.tipoCertificados = [...this.tipoCertificados];
    this.tipoCertificados.splice(i,1);
    this.tcSeleccionados = [...this.tcSeleccionados, tc].sort((a, b) => (a.cert_codigo < b.cert_codigo ? -1 : 1));
    this.getCerTipo()?.setValue(this.tcSeleccionados);
  }

  onClickDeseleccionar(tc:ICertificadoTipoDTO,i:number){
    this.tcSeleccionados = [...this.tcSeleccionados];
    this.tcSeleccionados.splice(i,1);
    this.tipoCertificados = [...this.tipoCertificados, tc].sort((a, b) => (a.cert_codigo < b.cert_codigo ? -1 : 1));;
    this.getCerTipo()?.setValue(this.tcSeleccionados);
  }

  onSubmit():void{
    this.modalService.open(ModalCargandoComponent, { animation: true, backdrop: 'static', keyboard: false });
    
    this.cerCerTipoService.getVistaPrevia(this.getCerTipo()?.value, this.getCerDependencia()?.value, this.getPeriodoInicio()?.value, this.getPeriodoFin()?.value).subscribe(
      res => {
        this.modalService.dismissAll();
        this.certificadoInfo = res.body!;
        this.modalService.open(this.popupVistaPrevia, { size: 'xl' });
      },
      () => {
        this.modalService.dismissAll();
        const refError = this.modalService.open(ModalErrorComponent, { animation: true, backdrop: 'static', keyboard: false });
        refError.componentInstance.mensaje = 'Ha ocurrido un error al generar la vista previa';
      }
    );
  }

  imprimirCertificado(): void {
    console.log('Entrooo imprimir ');
    this.modalService.dismissAll();
    this.modalService.open(ModalCargandoComponent, { animation: true, backdrop: 'static', keyboard: false });
    this.certificadoInfo.facCodigo = this.facCodigo;
    this.cerCerTipoService.generarCertificado(this.certificadoInfo).subscribe(
      res => {
        this.modalService.dismissAll();
        
        let nombreArchivo = this.codigoEstudiante.concat("_");
        const cerTipos: ICertificadoTipoDTO[] = this.getCerTipo()?.value;
        if (Number(this.getCerDependencia()?.value) === 1) {
          nombreArchivo = cerTipos.some(cert => cert.cert_codigo === 14) ? nombreArchivo.concat("ficha_academica") : nombreArchivo.concat("certificado_registro");
        } else {
          nombreArchivo = nombreArchivo.concat("certificado_liquidacion");
        }

        this.utilidadService.descargarArchivo(res.body, 'blob', nombreArchivo.toUpperCase(), ".pdf");

        this.router.navigate(['menu-certificaciones']);
      },
      () => {
        this.modalService.dismissAll();
        this.router.navigate(['menu-certificaciones']);
        const refError = this.modalService.open(ModalErrorComponent, { animation: true, backdrop: 'static', keyboard: false });
        refError.componentInstance.mensaje = 'Ha ocurrido un error al generar el certificado';
      }
    );
  }

  // Fetchs

  private findAllDependencias():void{

    this.cerdService.findAll(this.litCodigo.toString()).subscribe(
      (res) =>{
        //console.log(res);
        this.dependencias = res.body!;
      },
      (err)=>{
        //console.error(err);
      }
    );
  }

  private findCodigoEstudiante(): void {
    this.seguridadService.getCredenciales().subscribe(res => {
      this.codigoEstudiante = res!.sub.slice(1);
    });
  }

  private findAllCertificadoTiposByCerdcodigoAndLiqcodigo(cerdCodigo:string,liqCodigo:string):void{
    this.modalService.open(ModalCargandoComponent, { animation: true, backdrop: 'static', keyboard: false });
    this.certService.findAllByCerdcodigoAndLiqcodigo(cerdCodigo,liqCodigo).subscribe(
      (res) =>{
        //console.log(res);
        this.modalService.dismissAll();
        this.tipoCertificados = res;
      },
      (err)=>{
        //console.error(err);
        this.modalService.dismissAll();
        const refError = this.modalService.open(ModalErrorComponent, { animation: true, backdrop: 'static', keyboard: false });
        refError.componentInstance.mensaje = 'Ha ocurrido un error al obtener la información. Causas: La liquidación facturada no es válida o no corresponde al usuario.';
      }
    );
  }

  getPeriodos(): void {
    this.periodoService.obtenerPorPeriodoInicioEstudiante(this.getCerDependencia()?.value).subscribe(res => this.periodos = res);
  }

  periodoInicioConditionallyRequiredValidator(abstractControl: AbstractControl): any {
    const elmId = abstractControl.get('elmId')?.value;
    const ecrFechaIPuesto = abstractControl.get('ecrFechaIPuesto')!.value;
    if (Number(elmId) === 2 && (ecrFechaIPuesto === null || ecrFechaIPuesto === undefined || ecrFechaIPuesto === '')) {
      abstractControl.get('ecrFechaIPuesto')!.setErrors({
        PuestoFIRequired: true,
      });
    } else {
      return null;
    }
  }
}


